import { render, staticRenderFns } from "./PeriodFilters.vue?vue&type=template&id=c040da3e&"
import script from "./PeriodFilters.vue?vue&type=script&lang=ts&"
export * from "./PeriodFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports